module.exports = __webpack_public_path__ + "ECMv6/static/media/Saviynt-logo.4c5ffb4b.svg";